var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_6)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3341 5.625C13.2884 6.50207 13.1465 7.37534 12.9085 8.22871C13.84 7.67688 14.5122 6.73338 14.6981 5.625L13.3341 5.625ZM11.4354 8.72499C11.2926 8.74151 11.1473 8.75 11 8.75C10.8527 8.75 10.7074 8.74151 10.5645 8.72499C10.1945 7.72152 9.97894 6.67668 9.9178 5.625L12.0822 5.625C12.021 6.67668 11.8055 7.72152 11.4354 8.72499ZM13.3341 4.375C13.2884 3.49793 13.1465 2.62466 12.9085 1.77129C13.84 2.32312 14.5122 3.26663 14.6981 4.375L13.3341 4.375ZM12.0822 4.375C12.021 3.32332 11.8055 2.27848 11.4354 1.27501C11.2926 1.25849 11.1473 1.25 11 1.25C10.8527 1.25 10.7074 1.25849 10.5645 1.27501C10.1945 2.27848 9.97894 3.32332 9.9178 4.375L12.0822 4.375ZM8.66591 4.375C8.71158 3.49793 8.85345 2.62466 9.0915 1.77129C8.15995 2.32312 7.48779 3.26663 7.30184 4.375H8.66591ZM9.0915 8.22871C8.85344 7.37533 8.71158 6.50207 8.66591 5.625H7.30184C7.48779 6.73337 8.15995 7.67688 9.0915 8.22871ZM11 10C13.7614 10 16 7.76142 16 5C16 2.23858 13.7614 0 11 0C8.23857 0 5.99999 2.23858 5.99999 5C5.99999 7.76142 8.23857 10 11 10ZM2.24999 9.5H1.49999L1.49999 11H2.24999H3.93933L0.719661 14.2197L0.189331 14.75L1.24999 15.8107L1.78032 15.2803L4.99999 12.0607V13.75V14.5H6.49999V13.75L6.49999 10.5C6.49999 9.94771 6.05228 9.5 5.49999 9.5L2.24999 9.5Z",
    fill: "#D0D0D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalLink);
export default __webpack_public_path__ + "static/media/global-link.2d0e0d8517a5737e3b37480c0c05b235.svg";
export { ForwardRef as ReactComponent };